export default __webpack_public_path__ + "static/media/icone check.1688aa82.svg";